export enum UserEvent {
  Alert = 'Alert',
  Error = 'Error',
  Update = 'Update',
  Create = 'Create'
} 